module.exports = __webpack_public_path__ + "static/media/banner-ensina-by-fs.72098bd8.png";